export const scrollTop = () => {
	window.scrollTo({
		top: '5000px',
		behavior: 'smooth',
	});
};
